export { default } from './VehicleDetails';
